import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
  arr = [1, 2, 3, 4, 5]
  loading = false
  objArr = [];
  pageNo
  pageSize
  totalItems
  error
  errorloading = false
  constructor(private authService: AuthservicesService, private router: Router) {
    this.pageSize = this.authService.pageSize
  }

  ngOnInit(): void {
    this.getNotification(1);
  }

  getNotification(event) {
    this.pageNo = event
    let skip = this.authService.createSkip(this.pageNo, this.pageSize);
    this.authService.getnotifications(skip, this.pageSize).subscribe((res: any) => {
      this.loading = true
      this.errorloading = false
      this.totalItems = res.total;
      res.items.forEach(element => {
        let obj = {
          description: (element.description) ? element.description : '',
          createdAt: (element.createdAt) ? element.createdAt : '',
          type: 'notification',
          title: (element.type) ? element.type : '',
          from: element?.from
        }

        this.objArr.push(obj)
      });
    },
      error => {
        this.error = error.error.data
        this.errorloading = true
        // this.objArr =[];

      })
  }


  jumptoScreen(props) {
    let route
    switch (props.title) {
      case 'createAnnouncement':
        route = "/post-cards"
        break;
      case 'generalMessage':
        route = "/alerts"
        break;
      case 'importantUpdate':
        route = "/alerts"
        break;
      case 'emergencyUpdate':
        route = "/alerts"
        break;

      case 'emergencyUpdate':
        route = "/alerts"
        break;
      case "commentOnPost":
        route = "/social-post"
        break;

      case "SharePost":
        route = "/social-post"
        break;

      case "likePost":
        route = "/social-post"
        break;

      default:
    }
    return route
  }

  navigateToPartner(props) {
    if (props.title === 'partnerRequest') {
      Swal.fire({
        title: 'Do you want to accept it ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Accept Request',
        cancelButtonText: 'Reject Request',
      }).then((result) => {
        if (result.value) {
          this.acceptRejectRequest(props, true);
        }
        else {
          this.acceptRejectRequest(props, false);
        }
      });
    }
  }

  acceptRejectRequest(props: any, isApproved: Boolean) {
    let data = {
      isApproved: isApproved,
      requestedBy: props?.from?.id
    }
    this.authService.acceptDeclinePartnerRequest(data).subscribe((res: any) => {
      if (res?.is_success === true) {
        this.router.navigate(['/our-network'])
      }
    },
      (error) => {
        console.error(error)
      }
    )

  }


}
